// components/Footer.tsx
import { Mail, MapPin, Phone } from 'lucide-react';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';

//  UPDATED SHOP DETAILS (Taken from ShopDetailsPage.tsx)
const SHOP_DETAILS = {
  addressLine1: "Sardar Jewellers, purana shivli road, near balaji shadi cards", 
  addressLine2: " Kalayanpur, Kanpur, Uttar Pradesh 208016", 
  phone: "+91 8441856072", 
  email: "ashutoshrajput203@gmail.com", 
};


const Footer = () => {
  //  Social Icon Class for Circle & Hover Effect
  const socialIconClass = "p-2 rounded-full text-gray-700 bg-gray-200 hover:bg-[#c49a6c] hover:text-white transition duration-300";

  return (
    <footer className="text-gray-700">
      
      

      {/* Main Footer Content */}
      <div className="bg-[#f8f5ef] py-12 px-6 md:px-20">
        <div className="grid md:grid-cols-4 gap-10 mb-10">
          
          {/* Branding & Newsletter */}
          <div>
            <h2 className="text-xl font-semibold mb-4 text-[#a77d3d]">Sardar Jewellers</h2>
            <p className="mb-4">
              Don’t miss any updates or promotions by signing up to our newsletter.
            </p>
            <div className="flex items-center">
              <input
                type="email"
                placeholder="Enter your email"
                className="p-2 border border-gray-300 rounded-l-md w-full focus:outline-none focus:border-[#a77d3d]"
              />
              <button className="bg-[#a77d3d] text-white px-4 py-2 rounded-r-md hover:bg-[#8f6932] transition">
                &gt;
              </button>
            </div>
          </div>

          {/* Our Policies */}
          <div>
            <h3 className="text-lg font-medium mb-4 text-gray-800">Our Policies</h3>
            <ul className="space-y-2">
              <li><a href="/privacy" className="hover:text-[#a77d3d] transition">Privacy Policy</a></li>
              <li><a href="/refund" className="hover:text-[#a77d3d] transition">Refund Policy</a></li>
              <li><a href="/term" className="hover:text-[#a77d3d] transition">Terms of Usage</a></li>
              {/* <li><a href="/shipping" className="hover:text-[#a77d3d] transition">Shipping Policy</a></li> */}
            </ul>
          </div>

          {/* Useful Links & Social Icons */}
          <div>
            <h3 className="text-lg font-medium mb-4 text-gray-800">Useful Links</h3>
            <ul className="space-y-2 mb-6">
              <li><a href="/about" className="hover:text-[#a77d3d] transition">About Us</a></li>
              <li><a href="/contact" className="hover:text-[#a77d3d] transition">Contact Us</a></li>
              {/* <li><a href="/sitemap" className="hover:text-[#a77d3d] transition">Sitemap</a></li> */}
            </ul>
            
            {/* <h3 className="text-lg font-medium mb-3 text-gray-800">Connect</h3> */}
           
            <div className="flex gap-3">
              <a href="#" className={socialIconClass}><FaFacebookF size={18} /></a>
              <a href="#" className={socialIconClass}><FaInstagram size={18} /></a>
              <a href="#" className={socialIconClass}><FaYoutube size={18} /></a>
            </div>
          </div>

          {/* Contact Details ( 3. Updated Details) */}
          <div>
            <h3 className="text-lg font-medium mb-4 text-gray-800">Contact Details</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Phone size={18} className="text-[#a77d3d] mt-0.5 flex-shrink-0" />
                <span>{SHOP_DETAILS.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={18} className="text-[#a77d3d] mt-0.5 flex-shrink-0" />
                <span>{SHOP_DETAILS.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={18} className="text-[#a77d3d] mt-0.5 flex-shrink-0" />
                <span>
                  {SHOP_DETAILS.addressLine1}
                  <br />
                  {SHOP_DETAILS.addressLine2}
                </span>
              </li>
            </ul>
          </div>
        </div>

      {/* Payment + App Links  */}
      {/* <div className="flex flex-col items-center border-t border-gray-300 pt-6 text-sm text-gray-500 sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0"> */}
          {/* <div className="flex gap-3">
            <img src="https://upload.wikimedia.org/wikipedia/commons/4/41/Visa_Logo.png" alt="Visa" className="h-6"/>
            <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="MasterCard" className="h-6"/>
            <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" className="h-6"/>
          </div> */}

         

          {/* <div className="flex gap-4">
            <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer">
              <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" className="h-8"/>
            </a>
            <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
              <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="App Store" className="h-8"/>
            </a>
          </div> */}
      {/* </div> */}
      </div>

    <div className="border-t border-amber-300 bg-[#a77d3d]/90 text-white py-2 text-center text-xs font-medium tracking-wide">
   <p className="text-center w-full sm:w-auto">
            © {new Date().getFullYear()} Sardar Jewellers | All rights reserved
          </p>
</div>



    </footer>
  );
};

export default Footer;